const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/PageSubHeader.tsx';
import React from 'react';
import { Card, Icon, Typography, TypographyProps } from '@mui/material';
import { css, cx } from '@emotion/css';
import { theme } from '../utils/clientSetupManager';

const cardTitleStyle = css`
    color: ${theme.palette.primary.contrastText};
    display: flex;
    align-items: center;
`;

const iconStyle = css`
    margin-right: ${theme.spacing(1)};
`;

type Props = {
    title: string;
    titleIcon: string;
    TitleProps?: TypographyProps;
};

const cssCardStyle = css`
    display: flex;
    justify-content: space-between;
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
    background-color: ${theme.palette.primary.main};
    align-items: center;
    margin-bottom: ${theme.spacing(2)};
`;

const PageSubHeader = (props: Props) => {
    return (
        <Card className={cssCardStyle}>
            <Typography variant="subtitle1" component="div" className={cx(cardTitleStyle, props.TitleProps?.className)}>
                {props.titleIcon && <Icon className={cx(props.titleIcon, iconStyle)} />}
                <span>{props.title}</span>
            </Typography>
        </Card>
    );
};

export default PageSubHeader;
